import script from "./TextHelpModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TextHelpModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__